
import {  AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { formatDate } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import { FormatDataTableGlobal, FormatDataTableGlobalFive } from 'src/app/web/util/formatDataTable';
import { payTemplate } from 'src/app/web/interfaces/project/payments/payments';
import Swal from 'sweetalert2';
import { ErrorService } from 'src/app/shared/services/errors.service';

export function FormatterPeso(): any {
    return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 2
    })
}

export function FormatterDolar(): any {
    return new Intl.NumberFormat('es-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    })
}

export function FormatterPesonNotDecimal(): any {
    return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0
    })
}

@Component({
  selector: 'app-ejecucion',
  templateUrl: './ejecucion.component.html',
  styleUrls: ['./ejecucion.component.scss']
})
export class PayEjecucionComponent implements  AfterViewInit, OnDestroy, OnInit  {
  @Input() pagos:payTemplate
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  paymentsform: FormGroup;
  fechasForm: FormGroup;
  dtOptions: DataTables.Settings = {dom:'1.5'};
  idProject
  nameproject
  tipomoneda
  listtype : [{id:number,
               name:string}];
  listapagos:[{description:string,monto:string}];

  items!: FormArray;  

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiServiceProject,
    private errorService:ErrorService
  ) { 
    this.route.params.subscribe((params) => {
      this.idProject = params['id'];
      this.nameproject = params['name'];
    });
  }

  ngOnInit(): void {
    this.spinner.show();
    this.dtOptions = FormatDataTableGlobalFive();
    this.paymentsform = this.fb.group({
      items: new FormArray([])  
    });
    this.selectMoneda()
    for(let i = 0 ; i < this.pagos.listPlay.length; i++){
    
      this.items = this.paymentsform.get('items') as FormArray;  
      let pago = this.pagos.listPlay[i].monto
        pago = pago.replace('$','')
      
      let info = this.fb.group({  
        
          title: this.pagos.listPlay[i].description,
          pay_amount:pago,
          amount_percent: 0,
          scheduled_date:''
        
      });  

      this.items.push(info);
    }


    // this.fechasForm = this.fb.group({
    // });
    // for(let i = 0 ; i < this.pagos.listPlay.length; i++){
    //   this.Paymentsform.addControl('title'+ i, new FormControl(this.pagos.listPlay[i].description));
    //   this.Paymentsform.addControl('scheduled_date'+ i, new FormControl('2020-11-24'));
      
    // }
    this.listapagos = this.pagos.listPlay 
    this.rerender()
    this.spinner.hide();
  }
  selectMoneda(){
    if(this.pagos.playOptionDescription != 'CLP' && this.pagos.playOptionDescription != 'Paraguayo') {
        this.tipomoneda = FormatterPeso()
      }
      else
      {
        this.tipomoneda = FormatterPesonNotDecimal()
      }
    }
  validate(info){

  }
  get form() {
    return this.paymentsform.controls;
  }

  formSubmit(){

    var form = document.getElementsByClassName('needs-validation')[0] as HTMLFormElement;
    if (form.checkValidity() === false) {
      form.classList.add('was-validated');
    } else {
      this.btnGuardar()
    }

  
  }
  btnGuardar(){
    this.spinner.show()
    let array = []
    this.items.value.map((d)=>{
      let realStartDateDay =
                d.scheduled_date.split('-')[2];
              let realStartDateMonth =
                d.scheduled_date.split('-')[1];
              let realStartDateYear =
                d.scheduled_date.split('-')[0];
              let realStartDate =
                realStartDateDay +
                '-' +
                realStartDateMonth +
                '-' +
                realStartDateYear;
                let pago=d.pay_amount;
                pago = pago.replace('$','')

      array.push({
        title: d.title,
        pay_amount: pago,
        amount_percent: 0,
        scheduled_date: realStartDate
      })
    })
     let post = {
       pay_amount_total:this.pagos.monto,
       projects_id : Number(this.idProject),
       project_attachments_id :0,
       money_type_id:Number(this.pagos.play_option_id),
       templete_id:Number(this.pagos.templete_id),
       listProjectPlayInfo:array
     }

     this.apiService
         .postService('project-play-create', post)
         .subscribe({
           next: (rs: any) => {
            if(rs.code){
               this.spinner.hide();
               Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
             }
             else{
               this.spinner.hide();
               this.spinner.hide()
               Swal.fire({title:rs.message,text: '',icon: 'success',heightAuto: false}).then(()=>{
                this.router.navigate([`/pdg/project/pay/list/${this.idProject}/${this.nameproject}`]);
               });
           }
           },
           error: (error) => {
             this.errorService.error(error);
           },
         });
    
  }


  // formSubmit(){
  //   let array = []
  //   let arrayfecha = []
  //   let arraytitle = []
  //   for(const property in this.Paymentsform.value) {
  //     if(this.Paymentsform.value[property]== null || this.Paymentsform.value[property] == ''){
  //       return Swal.fire('Por favor rellene todos los campos', '', 'error');
  //     }
  //     let realStartDateDay =
  //               this.Paymentsform.value[property].split('-')[2];
  //             let realStartDateMonth =
  //               this.Paymentsform.value[property].split('-')[1];
  //             let realStartDateYear =
  //               this.Paymentsform.value[property].split('-')[0];
  //             let realStartDate =
  //               realStartDateDay +
  //               '-' +
  //               realStartDateMonth +
  //               '-' +
  //               realStartDateYear;
  //       if(realStartDateYear > 0 ){
  //         arrayfecha.push(realStartDate)
  //       }
  //       else{
  //          arraytitle.push(this.Paymentsform.value[property])
  //       }
  //   }
  //   let i=0
  //   this.pagos.listPlay.map((d)=>{
  //     array.push({
  //       title:arraytitle[i],
  //       scheduled_date:arrayfecha[i],
  //       pay_amount:d.monto,
  //       amount_percent: 0,
  //     })
  //     i=i+1
  //   })
    
  //   let post = {
  //     pay_amount_total:this.pagos.monto,
  //     projects_id : Number(this.idProject),
  //     project_attachments_id :0,
  //     money_type_id:Number(this.pagos.play_option_id),
  //     templete_id:Number(this.pagos.templete_id),
  //     listProjectPlayInfo:array

  //   }
  //   this.apiService
  //       .postService('project-play-create', post)
  //       .subscribe({
  //         next: (rs: any) => {
  //           if(rs.code){
  //             this.spinner.hide();
  //             Swal.fire( rs.error + '', '', 'error');
  //           }
  //           else{
  //             this.spinner.hide();
  //             Swal.fire(rs.message + '', '', 'success');
  //           }
  //         },
  //         error: (error) => {
  //           this.spinner.hide();
  //           Swal.fire({title:  error.error.message +'',text: '',icon: 'error',heightAuto: false});
  //         },
  //       });
  // }

   ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    
  }
}
